import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  fullscreen?: boolean;
  label?: string;
  className?: string;
}

export function LoadingSpinner({ fullscreen, label, className }: LoadingSpinnerProps) {
  const inner = (
    <div className={cn('inline-flex items-center gap-3 text-muted-foreground', className)}>
      <Loader2 className="h-4 w-4 animate-spin" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
  if (!fullscreen) return inner;
  return (
    <div
      className="flex min-h-svh items-center justify-center bg-background"
      data-testid="loading-spinner"
    >
      {inner}
    </div>
  );
}
